import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AppSubHeaderComponent } from './app-sub-header.component';
import { TooltipModule } from 'primeng/primeng';

@NgModule({
  imports: [
    CommonModule,
    TooltipModule,
  ],
  declarations: [ AppSubHeaderComponent ],
  exports: [ AppSubHeaderComponent ]
})
export class AppSubHeaderModule {
}
